import {
  useGPStatusCreate,
  useGPStatusEdit,
  useGPStatusList,
} from '@/core/domain/visual-management/status/status.hooks';
import { Alert, Modal, ModalProps, Radio, Space, Typography } from 'antd';
import { useState } from 'react';
import { Group } from '@/components/_common';
import SkeletonCustom from '@/components/_common/SkeletonCustom';

import './style.less';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
}

export default function CompleteActivityClosingWorkOrderModal(props: Props) {
  const [value, setValue] = useState('');

  const statusList = useGPStatusList(props.open);
  const editStatus = useGPStatusEdit();
  const createStatus = useGPStatusCreate();

  function handleCancel() {
    setValue('');
    props.onCancel();
  }

  async function handleOk() {
    if (!!value) {
      const findStatus = statusList.data?.find(({ id }) => id === value);

      await editStatus.mutateAsync({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...findStatus!,
        id: value,
        type: 3,
      });
    } else {
      await createStatus.mutateAsync({
        name: 'Concluido',
        color: 'green',
        type: 3,
      });
    }

    handleCancel();
  }

  return (
    <Modal
      {...props}
      title="Cadastro de tipo de status"
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Salvar"
      confirmLoading={createStatus.isLoading || editStatus.isLoading}
    >
      <Alert
        type="info"
        style={{ marginBottom: 16 }}
        message="Gerenciamento de status"
        description={
          <Typography.Text>
            Crie um status automaticamente ou selecione o status desejado para o
            qual o card será movimentado quando for concluído.
          </Typography.Text>
        }
      />

      <div className="status-scroll-wrapper">
        <Radio.Group
          className="status-card-group"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        >
          <Space direction="vertical" style={{ width: '100%' }}>
            <Radio value="" className="status-card">
              Gerar automático
            </Radio>

            <SkeletonCustom
              loading={statusList.isLoading}
              skeletonType="INPUT"
              skeletonCount={1}
            />

            {statusList.data?.map((item) => (
              <Radio key={item.id} value={item.id} className="status-card">
                <Group className="status-card-content">
                  <span
                    className="status-color"
                    style={{ backgroundColor: item.color }}
                  />
                  <span>{item.name}</span>
                </Group>
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </div>
    </Modal>
  );
}
